import { Song } from "../../view/spotipitan/types";
import SquareImage from "../square-image/square-image";
import './image-mosaic.scss';

interface Props {
    images?: string[];
    songs?: Song[];
    rows?: number;
    columns?: number;
}

const ImageMosaic = ({ images, songs, rows = 2, columns = 2 }: Props) => {
    return (
        <div className="image-mosaic" style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gridTemplateRows: `repeat(${rows}, 1fr)`,
            width: '100%',
            height: '100%',
        }}>
            {songs && songs.length > 0 ? (
                songs.map((song) => (
                    <SquareImage key={song.id} fill hideBackground song={song} alt={song.name} style={{
                        aspectRatio: '1/1',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        width: '100%',
                        height: '100%',
                    }} />
                ))
            ) : (
                images?.map((image) => (
                    <SquareImage key={image} fill hideBackground src={image} alt="image" style={{
                        aspectRatio: '1/1',
                        objectFit: 'cover',
                        objectPosition: 'center',
                        width: '100%',
                        height: '100%',
                    }} />
                ))
            )}
        </div>
    );
}

export default ImageMosaic;
